import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateTimeSpanish'
})
export class DateTimeSpanishPipe implements PipeTransform {

  transform(value: string | Date): string {
    if (!value) {
      return '';
    }

    const date = new Date(value);
    
    if (isNaN(date.getTime())) {
      return '';
    }

    return date.toLocaleString('es-ES', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  }
}
